import { render, staticRenderFns } from "./mdc-headline4.vue?vue&type=template&id=1613d651&"
import script from "./mdc-headline4.vue?vue&type=script&lang=ts&"
export * from "./mdc-headline4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports